// extracted by mini-css-extract-plugin
module.exports = {"container":"ListBlock_container__TRY3i","title":"ListBlock_title__s6dtm"};